import { render, staticRenderFns } from "./CustomerOrdersView.vue?vue&type=template&id=53da8696&"
import script from "./CustomerOrdersView.vue?vue&type=script&lang=js&"
export * from "./CustomerOrdersView.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOrdersView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports